import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IPopularizeRecord, defaultValue } from 'app/shared/model/popularize-record.model';
// 接口
export const ACTION_TYPES = {
  FETCH_POPULARIZERECORD_LIST: 'popularizeRecord/FETCH_POPULARIZERECORD_LIST',
  FETCH_POPULARIZERECORD: 'popularizeRecord/FETCH_POPULARIZERECORD',
  CREATE_POPULARIZERECORD: 'popularizeRecord/CREATE_POPULARIZERECORD',
  UPDATE_POPULARIZERECORD: 'popularizeRecord/UPDATE_POPULARIZERECORD',
  DELETE_POPULARIZERECORD: 'popularizeRecord/DELETE_POPULARIZERECORD',
  RESET: 'popularizeRecord/RESET'
};
// state
const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IPopularizeRecord>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false
};

export type PopularizeRecordState = Readonly<typeof initialState>;

// Reducer

export default (state: PopularizeRecordState = initialState, action): PopularizeRecordState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_POPULARIZERECORD_LIST):
    case REQUEST(ACTION_TYPES.FETCH_POPULARIZERECORD):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_POPULARIZERECORD):
    case REQUEST(ACTION_TYPES.UPDATE_POPULARIZERECORD):
    case REQUEST(ACTION_TYPES.DELETE_POPULARIZERECORD):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_POPULARIZERECORD_LIST):
    case FAILURE(ACTION_TYPES.FETCH_POPULARIZERECORD):
    case FAILURE(ACTION_TYPES.CREATE_POPULARIZERECORD):
    case FAILURE(ACTION_TYPES.UPDATE_POPULARIZERECORD):
    case FAILURE(ACTION_TYPES.DELETE_POPULARIZERECORD):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_POPULARIZERECORD_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10)
      };
    case SUCCESS(ACTION_TYPES.FETCH_POPULARIZERECORD):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_POPULARIZERECORD):
    case SUCCESS(ACTION_TYPES.UPDATE_POPULARIZERECORD):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_POPULARIZERECORD):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/popularize-records';

// Actions

export const getEntities: ICrudGetAllAction<IPopularizeRecord> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_POPULARIZERECORD_LIST,
    payload: axios.get<IPopularizeRecord>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`)
  };
};

export const getEntity: ICrudGetAction<IPopularizeRecord> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_POPULARIZERECORD,
    payload: axios.get<IPopularizeRecord>(requestUrl)
  };
};

export const createEntity: ICrudPutAction<IPopularizeRecord> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_POPULARIZERECORD,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IPopularizeRecord> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_POPULARIZERECORD,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const deleteEntity: ICrudDeleteAction<IPopularizeRecord> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_POPULARIZERECORD,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
